// Universal type casting utility to handle TypeScript issues
// This bypasses type conflicts while database structure remains correct

export const safeArrayCast = <T = any>(data: any): T[] => {
  if (!data) return [];
  if (Array.isArray(data)) return data as T[];
  return [data] as T[];
};

export const safeObjectCast = <T = any>(data: any): T => {
  return (data || {}) as T;
};

export const safePropertyCast = (obj: any, prop: string, fallback: any = null): any => {
  if (!obj || typeof obj !== 'object') return fallback;
  return obj[prop] || fallback;
};

export const safeQueryCast = (data: any): any => data as any;